class ProductCommunityPrints extends HTMLElement {
  constructor() {
    super();
    this.activeOpener = null;
    this.handleClick = this.handleClick.bind(this);
    this.handleKeydown = this.handleKeydown.bind(this);
    this.handleResize = this.handleResize.bind(this);
  }

  connectedCallback() {
    this.modal = this.querySelector('[data-community-print-modal]');
    this.modalImage = this.querySelector('[data-community-print-image]');
    this.modalWindow = this.querySelector('.community-prints__modal-window');
    this.viewport = this.querySelector('.community-prints__viewport');
    this.track = this.querySelector('.community-prints__track');
    this.primaryList = this.querySelector('.community-prints__list');
    this.addEventListener('click', this.handleClick);
    window.addEventListener('resize', this.handleResize);
    this.setupMarquee();
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.handleClick);
    window.removeEventListener('resize', this.handleResize);
    document.removeEventListener('keydown', this.handleKeydown);
    window.clearTimeout(this.resizeTimer);
  }

  handleResize() {
    window.clearTimeout(this.resizeTimer);
    this.resizeTimer = window.setTimeout(() => this.setupMarquee(), 150);
  }

  handleClick(evt) {
    const opener = evt.target.closest('[data-community-print-open]');
    if (opener && this.contains(opener)) {
      this.open(opener);
      return;
    }

    if (evt.target.closest('[data-community-print-close]')) {
      this.close();
    }
  }

  handleKeydown(evt) {
    if (evt.key === 'Escape') {
      this.close();
    }
  }

  open(opener) {
    if (!this.modal || !this.modalImage || !opener.dataset.communityPrintSrc) return;

    this.activeOpener = opener;
    this.modalImage.src = opener.dataset.communityPrintSrc;
    this.modalImage.alt = opener.dataset.communityPrintAlt || '';
    this.modal.hidden = false;
    document.documentElement.classList.add('community-prints-modal-open');
    document.addEventListener('keydown', this.handleKeydown);

    window.requestAnimationFrame(() => {
      this.modalWindow?.focus();
    });
  }

  setupMarquee() {
    if (!this.viewport || !this.track || !this.primaryList) return;

    this.querySelectorAll('[data-community-print-clone]').forEach((clone) => clone.remove());
    this.classList.remove('is-scrolling');

    const loopWidth = this.primaryList.offsetWidth;
    const viewportWidth = this.viewport.clientWidth;
    if (this.primaryList.children.length < 2 || !loopWidth || loopWidth <= viewportWidth) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    const startOffset = (viewportWidth - loopWidth) / 2;

    this.track.style.setProperty('--community-prints-loop-width', `${loopWidth}px`);
    this.track.style.setProperty('--community-prints-start-offset', `${startOffset}px`);

    let renderedWidth = loopWidth;
    const targetWidth = viewportWidth + loopWidth + Math.abs(startOffset);

    while (renderedWidth < targetWidth) {
      const clone = this.primaryList.cloneNode(true);
      clone.setAttribute('aria-hidden', 'true');
      clone.setAttribute('data-community-print-clone', '');
      clone.querySelectorAll('button').forEach((button) => {
        button.setAttribute('tabindex', '-1');
      });
      clone.querySelectorAll('img').forEach((image) => {
        if (image.dataset.src) image.src = image.dataset.src;
        if (image.dataset.srcset) image.srcset = image.dataset.srcset;
        image.classList.remove('no-js-hidden');
      });
      this.track.appendChild(clone);
      renderedWidth += loopWidth;
    }

    this.classList.add('is-scrolling');
  }

  close() {
    if (!this.modal || this.modal.hidden) return;

    this.modal.hidden = true;
    this.modalImage.removeAttribute('src');
    this.modalImage.alt = '';
    document.removeEventListener('keydown', this.handleKeydown);

    if (!document.querySelector('.community-prints__modal:not([hidden])')) {
      document.documentElement.classList.remove('community-prints-modal-open');
    }

    this.activeOpener?.focus();
    this.activeOpener = null;
  }
}

if (!customElements.get('product-community-prints')) {
  customElements.define('product-community-prints', ProductCommunityPrints);
}
